import clsx from "clsx";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useRouter } from "next/router";
import Icon from "@Components/ui/icon";
import { cartDrawerSelector } from "@wff/store/cartDrawerSlice";
import { useAppSelector } from "@wff/store/hooks";
import { useProductsFilter } from "../context/ProductsFilterContext";
import { IProductsListingPageContent } from "../types";
import { changeProductsSearchCriteriaInURL } from "../utils";
import { StickyFacetsMenu } from "./StickyFacetsMenu";
import classes from "./StickyToolbar.module.scss";

interface ToolbarProps extends IProductsListingPageContent {}

export const StickyToolbar = (props: ToolbarProps) => {
  const { resetFilter, toggleMobileDrawerMenu, countSelectedFilterValues } =
    useProductsFilter();

  const router = useRouter();
  const { isVisible: isNavbarVisible } = useAppSelector(cartDrawerSelector);

  const onFilterClick = () => {
    toggleMobileDrawerMenu();
  };
  const isMobile = useMediaQuery("(max-width:60em)");
  const onResetFilters = () => {
    resetFilter();
    changeProductsSearchCriteriaInURL(router, null);
  };
  const showCounter = countSelectedFilterValues > 0;
  const showDesktopFilter = showCounter || !isMobile;

  return (
    <div
      className={clsx(
        classes["toolbar"],
        isNavbarVisible && classes["toolbar--top"]
      )}
    >
      <h2 className={classes["toolbar-title"]}>{props.pageTitle}</h2>
      {!showCounter && isMobile && (
        <button className={classes["filter-mobile"]} onClick={onFilterClick}>
          <Icon iconName="filter" />
          {props["plp.page.filter"]}
        </button>
      )}
      <div
        className={clsx(
          classes["toolbar-header"],
          isNavbarVisible && classes["toolbar-header--top"]
        )}
      >
        {showDesktopFilter && (
          <div className={classes["toolbar-menu"]}>
            <button
              className={clsx(
                classes["filter-toggle"],
                showCounter && classes["filter-toggle--active"]
              )}
              onClick={onFilterClick}
            >
              <Icon iconName="filter" />
              {props["plp.page.filter"]}
              {showCounter && isMobile && (
                <span className={classes["filter-toggle-count"]}>
                  ({countSelectedFilterValues})
                </span>
              )}
            </button>
            {showCounter && (
              <button
                className={classes["filter-clear"]}
                onClick={onResetFilters}
                disabled={false}
              >
                Clear all filters
              </button>
            )}
          </div>
        )}
        <StickyFacetsMenu {...props} />
      </div>
    </div>
  );
};
